/* Saved Studio colorways keep the original layout and change only valid tile colors (wainscoting may opt into a different repeat). */
(function (root, factory) {
  var api = root && root.PdpStudioColorways || factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PdpStudioColorways = api;
})(typeof window !== 'undefined' ? window : null, function () {
  var requests = new Map();
  var defaultBase = 'https://studiov2.feltright.com';
  function meta(shape) { return shape.metadata || shape.attrs && shape.attrs.metadata || {}; }
  function key(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function round(value) { return Math.round(Number(value) * 100) / 100; }
  function rotation(shape) { return ((Number(shape.rotation ?? shape.attrs?.rotation) || 0) % 360 + 360) % 360; }
  function fingerprint(shape, origin) {
    var m = meta(shape);
    // Studio's current half-circle serializer omits its fixed catalog dimensions.
    var halfCircle = shape.type === 'arc' && m.shape_label === 'HalfCircle' &&
      m.shape_id === 'HalfCircleHorizontal' && (!m.handle || m.handle === 'half-circle-tile');
    var width = Number(shape.width ?? (halfCircle ? 120 : NaN)), height = Number(shape.height ?? (halfCircle ? 60 : NaN));
    var values = [Number(shape.x), Number(shape.y), width, height];
    if (!values.every(Number.isFinite) || width <= 0 || height <= 0) throw new Error('This colorway must use the same tile layout as the original.');
    return JSON.stringify([round(shape.x - origin.x), round(shape.y - origin.y), width, height,
      Number(shape.offsetX ?? width / 2), Number(shape.offsetY ?? (shape.type === 'arc' ? 0 : height / 2)),
      rotation(shape), shape.type, key(m.shape_label), key(m.shape_id), Number(m.depth) || 0]);
  }
  function origin(shapes) {
    return {x: Math.min.apply(null, shapes.map(s => Number(s.x))), y: Math.min.apply(null, shapes.map(s => Number(s.y)))};
  }
  function variationColor(variation, shapeLabel) {
    var parts = String(variation.label || '').split('-'), expected = key(String(shapeLabel || '').replace(/Set$/, ''));
    if (key(parts[0]) === expected) return parts.slice(1).join('-').trim();
    if (key(parts[parts.length - 1]) === expected) return parts.slice(0, -1).join('-').trim();
    return '';
  }
  function color(catalog, original, next) {
    var variation = (catalog || []).find(function (v) {
      return !v.archived_at && String(v.variant_id).split('/').pop() === String(next.variant_id).split('/').pop() &&
        variationColor(v, original.shape_label) &&
        (!original.handle || v.handle === original.handle);
    });
    if (!variation) throw new Error('A tile in this colorway no longer has an available color. Save it again in Studio.');
    return {variant_id: String(variation.variant_id), product_id: String(variation.product_id), handle: variation.handle,
      color_label: variationColor(variation, original.shape_label), price: Number(variation.price), photo_url: variation.photo};
  }
  // A colorway with its own repeat (e.g. 3 columns instead of 2) keeps its saved geometry but may use only the original's tile kinds.
  function repeat(originals, alternatives, catalog) {
    var kinds = new Map(originals.map(function (shape) { return [fingerprint(shape, shape), meta(shape)]; }));
    return alternatives.map(function (shape) {
      var original = kinds.get(fingerprint(shape, shape));
      if (!original) throw new Error('This colorway must use the same tiles as the original.');
      var next = meta(shape);
      return Object.assign({}, shape, {metadata: Object.assign({}, original, {set_id: next.set_id}, color(catalog, original, next))});
    });
  }
  function validate(base, saved, catalog, options) {
    var originals = base && base.shapes, alternatives = saved && saved.shapes;
    if (!Array.isArray(originals) || !originals.length || !Array.isArray(alternatives) || !alternatives.length)
      throw new Error('This colorway must use the same tile layout as the original.');
    if (alternatives.length !== originals.length) {
      if (!(options && options.repeat)) throw new Error('This colorway must use the same tile layout as the original.');
      return {id: saved.id, name: saved.design_name || '', grid_properties: saved.grid_properties || base.grid_properties || {},
        shapes: repeat(originals, alternatives, catalog)};
    }
    var buckets = new Map(), offset = origin(alternatives), baseOffset = origin(originals);
    alternatives.forEach(function (shape) {
      var signature = fingerprint(shape, offset);
      if (!buckets.has(signature)) buckets.set(signature, []);
      buckets.get(signature).push(shape);
    });
    var baseGroups = new Map(), savedGroups = new Map();
    var shapes = originals.map(function (shape, index) {
      var bucket = buckets.get(fingerprint(shape, baseOffset)), alternate = bucket && bucket.pop();
      if (!alternate) throw new Error('This colorway must use the same tile layout as the original.');
      var original = meta(shape), next = meta(alternate);
      // Set IDs may change on cloning, but membership must remain one-to-one.
      var group = original.set_id || 'tile-' + index, nextGroup = next.set_id || 'tile-' + index;
      if (baseGroups.has(group) && baseGroups.get(group) !== nextGroup || savedGroups.has(nextGroup) && savedGroups.get(nextGroup) !== group)
        throw new Error('Keep the original tile groups when saving a colorway.');
      baseGroups.set(group, nextGroup); savedGroups.set(nextGroup, group);
      return Object.assign({}, shape, {metadata: Object.assign({}, original, color(catalog, original, next))});
    });
    return {id: saved.id, name: saved.design_name || '', grid_properties: base.grid_properties || {}, shapes: shapes};
  }
  function request(url) {
    if (!requests.has(url)) {
      var controller = new AbortController(), timer = setTimeout(() => controller.abort(), 15000);
      var pending = fetch(url, {cache: 'no-store', signal: controller.signal}).then(function (response) {
        if (!response.ok) {
          var error = new Error('Could not load the saved Studio design. Check its ID and try again.');
          error.status = response.status;
          throw error;
        }
        return response.json();
      }).catch(function (error) {
        // A replacement editor section must be able to retry a transient failure.
        requests.delete(url);
        throw error;
      }).finally(() => clearTimeout(timer));
      requests.set(url, pending);
    }
    return requests.get(url);
  }
  async function load(baseId, colorwayId, baseUrl, options) {
    baseId = String(baseId || '').trim(); colorwayId = String(colorwayId || '').trim();
    if (![baseId, colorwayId].every(id => /^[A-Za-z0-9_-]+(?:\.\d+)?$/.test(id)))
      throw new Error('Enter a valid saved Studio design ID.');
    var base = (baseUrl || defaultBase).replace(/\/+$/, '');
    var results = await Promise.all([request(base + '/api/designs/' + encodeURIComponent(baseId)),
      request(base + '/api/designs/' + encodeURIComponent(colorwayId)),
      // Callers that already hold the catalog skip a second slow, uncached request.
      options && options.variations || request(base + '/api/variations')]);
    return validate(results[0], results[1], results[2], options);
  }
  function peakRows(design) {
    var labels = {smallpeak:['Small Peak',120,60],largecenterpeak:['Large Center Peak',240,60],largeupperpeak:['Large Upper Peak',240,60],quarter:['Quarter',60,60],half:['Halflap',120,60],shiplap:['Shiplap',60,240]};
    return design.shapes.map(function (shape) {
      var m = meta(shape), label = labels[key(m.shape_label)];
      if (!label || !((shape.width === label[1] && shape.height === label[2]) || (shape.width === label[2] && shape.height === label[1]))) throw new Error('This colorway contains an unsupported tile shape.');
      var r = rotation(shape), angle = r * Math.PI / 180;
      var dx = shape.width / 2 - Number(shape.offsetX ?? shape.width / 2);
      var dy = shape.height / 2 - Number(shape.offsetY ?? shape.height / 2);
      var turn = r + (shape.width !== label[1] ? 90 : 0) + (/180$/.test(m.shape_id || '') ? 180 : 0);
      return {variant_id: m.variant_id, tile_id: m.product_id, handle: m.handle, shape: label[0], color: m.color_label,
        quantity: 1, image: m.photo_url, configurations: [{
          tile_x_position: Number(shape.y) + dx * Math.sin(angle) + dy * Math.cos(angle),
          tile_y_position: Number(shape.x) + dx * Math.cos(angle) - dy * Math.sin(angle), tile_rotation: turn % 360,
        }]};
    });
  }
  async function peakCommerce(design, shopRoot) {
    var handles = [...new Set(design.shapes.map(s => meta(s).handle))];
    var products = await Promise.all(handles.map(handle => request((shopRoot || '/') + 'products/' + encodeURIComponent(handle) + '.js')));
    var variants = design.shapes.map(function (shape) {
      var m = meta(shape), product = products.find(p => p.handle === m.handle);
      var variant = product && product.variants.find(v => String(v.id) === String(m.variant_id));
      if (!variant || !Number.isFinite(Number(variant.price))) throw new Error('A tile in this colorway is no longer available.');
      return variant;
    });
    return {price: variants.reduce((total, v) => total + Number(v.price), 0), available: variants.every(v => v.available)};
  }
  function boxColors(design, sets) {
    var groups = new Map(), allBlocks = [], expected = [];
    design.shapes.forEach(function (shape) {
      var m = meta(shape), id = m.set_id;
      if (!id) throw new Error('This Studio design needs its original tile groups.');
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(shape);
    });
    var colors = sets.map(function (set) {
      var shapes = groups.get(set.id);
      if (!shapes || shapes.length !== set.blocks.length) throw new Error('Sync the original Studio layout before using this colorway.');
      var color = meta(shapes[0]).color_label;
      if (shapes.some(s => meta(s).color_label !== color)) throw new Error('Each 3D tile group must use one color.');
      shapes.forEach(function (s) {
        if (Math.round(Number(meta(s).depth) / 10) !== set.depth || rotation(s) % 90)
          throw new Error('Sync the original Studio layout before using this colorway.');
        var angle = rotation(s) * Math.PI / 180, ox = Number(s.offsetX ?? s.width / 2), oy = Number(s.offsetY ?? s.height / 2);
        var corners = [[0,0],[s.width,0],[0,s.height],[s.width,s.height]].map(p => [
          Number(s.x) + (p[0]-ox)*Math.cos(angle) - (p[1]-oy)*Math.sin(angle),
          Number(s.y) + (p[0]-ox)*Math.sin(angle) + (p[1]-oy)*Math.cos(angle)]);
        var xs = corners.map(p => p[0]), ys = corners.map(p => p[1]);
        allBlocks.push({id:set.id,x:round(Math.min(...xs)/120),y:round(Math.min(...ys)/120),
          w:Math.round((Math.max(...xs)-Math.min(...xs))/120),h:Math.round((Math.max(...ys)-Math.min(...ys))/120),rotation:rotation(s)});
      });
      set.blocks.forEach(b => expected.push(Object.assign({id:set.id}, b)));
      return color;
    });
    if (groups.size !== sets.length) throw new Error('Sync the original Studio layout before using this colorway.');
    function footprint(blocks) {
      var o = origin(blocks);
      return blocks.map(b => JSON.stringify([b.id,round(b.x-o.x),round(b.y-o.y),b.w,b.h,b.rotation||0])).sort().join('|');
    }
    if (footprint(allBlocks) !== footprint(expected)) throw new Error('Sync the original Studio layout before using this colorway.');
    return colors;
  }
  return {load:load, validate:validate, peakRows:peakRows, peakCommerce:peakCommerce, boxColors:boxColors};
});
